import React, { useState, useRef, useEffect } from 'react';

import Avatar from '@mui/material/Avatar';
import Dialog from '@mui/material/Dialog';
import Fab from '@mui/material/Fab';

import List from '@mui/material/List';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';

const defaultData = {
	lesson_status: 'todo',
	session_time: '',
	'score.raw': 0,
	'score.min': 0,
	'score.max': 0,
};

const SCORM = ({ name, url, label, value, onChange, errorMessage, ...props }) => {
	const [isReady, setReady] = useState(false);
	const [isExpanded, setExpanded] = useState(false);
	const [localData, setLocalData] = useState(defaultData);
	const dataRef = useRef({});

	const handleFullScreen = () => {
		window.parent.postMessage({ fullScreen: true }, '*');
		setExpanded(true);
	};

	const closeFullScreen = () => {
		const d = dataRef.current;
		const isPassed = d.lesson_status === 'passed';
		if(!isPassed && !confirm('Are you sure you want to close this screen? Your progress will not be saved.')) return;
		window.parent.postMessage({ fullScreen: false }, '*');
		setExpanded(false);
	};

	const handleValue = (k, v) => {
		console.log('LMSSetValue', k, v);
		const d = Object.assign({}, defaultData, dataRef.current);
		const key = k.replace('cmi.', '').replace('core.', '');
		d[key] = v;
		setLocalData(d);
		dataRef.current = d;
		if(d.lesson_status === 'passed')
			onChange && onChange({ target: { name, value: d }});
	};

	useEffect(() => {
		window.API = {
			LMSInitialize: d => console.log('LMSInitialize', d),
			LMSFinish: d => console.log('LMSFinish', d),
			LMSGetValue: d => console.log('LMSGetValue', d),
			LMSSetValue: (k, v) => handleValue(k, v),
			LMSCommit: d => console.log('LMSCommit', d),
			LMSGetLastError: d => console.log('LMSGetLastError', d),
			LMSGetErrorString: d => console.log('LMSGetErrorString', d),
			LMSGetDiagnostic: d => console.log('LMSGetDiagnostic', d),
		};

		setReady(true);
	});

	return (
		<div>
			<List sx={{ border: '1px solid rgba(0, 0, 0, 0.9)', borderRadius: '4px', padding: 0 }} {...props}>
				<ListItemButton onClick={handleFullScreen}>
					<ListItemAvatar>
						<Avatar>
							<ModelTrainingIcon />
						</Avatar>
					</ListItemAvatar>
					<ListItemText 
						primary={label || 'Launch E-Learning'} 
						secondary={`${String(localData?.lesson_status).toUpperCase()} ${errorMessage ?  `- ${errorMessage}` : ''}`} 
						secondaryTypographyProps={{
							color: errorMessage && 'error',
						}}
					/>
				</ListItemButton>
			</List>
			
			<Dialog
				fullScreen
				open={isExpanded}
				onClose={closeFullScreen}
			>	
				{isReady &&
				<iframe
					title="SCORM"
					allow="camera; microphone"
					style={{ width: '100%', height: '100%', border: 'none' }}
					src={url}
					{...props}
				/>}

				<Fab
					color="primary"
					size="small"
					style={{ position: 'absolute', left: 10, top: 30 }}
					onClick={closeFullScreen}
				>
					<ArrowBackIcon />
				</Fab>
			</Dialog>
		</div>
	);
};

SCORM.type = 'SCORM';

export default SCORM;